import objectAssign from 'object-assign';
import initialState from './initialState';
import * as ActionTypes from '../constants/actionTypes';




export default function accountDetailsReducer(state = initialState.accountDetails, action) {

    switch (action.type) {
        case ActionTypes.GET_USER_DETAILS_REQUEST:
            return objectAssign({}, state, { isFetching: true});
        case ActionTypes.GET_USER_DETAILS_SUCCESS:
            return objectAssign({}, state, 
        { 
            isFetching: false,
            firstName:action.data.firstName,
            lastName:action.data.lastName,
            email:action.data.email,
            phone:action.data.phone,
            data: action.data
        });
      case ActionTypes.GET_USER_DETAILS_FAILURE:
        return objectAssign({}, state, { isFetching: false});
     
      case ActionTypes.UPDATE_USER_DETAIL_INPUT:{
        return { ...state, [action.target.name]: action.target.value };
      }


      case ActionTypes.CHECK_VEHICLE_REG_FAILURE:
        {
          let modal = objectAssign({}, state["addVehicleModal"], { isFindingVehicle: false, vehicleReg: action.regNo, attemptedFind: true, error: action.error});
          let newState = {};
          newState["addVehicleModal"] = modal;
          return objectAssign({}, state, newState);
        }


    case ActionTypes.CHECK_VEHICLE_REG_REQUEST:
      {
        let modal = objectAssign({}, state["addVehicleModal"], { isFindingVehicle: true, vehicleReg: action.regNo });
        let newState = {};
        newState["addVehicleModal"] = modal;
        return objectAssign({}, state, newState);
      }


    case ActionTypes.CHECK_VEHICLE_REG_SUCCESS:
    {
      let modal = objectAssign({}, state["addVehicleModal"],
        {
          isFindingVehicle: false,
          attemptedFind: true,
          make: action.data.make,
          vehicleReg: action.regNo,
          model: action.data.model,
          color:action.data.color,
          licensePlate: action.data.licensePlate
        }
      );
      let newState = {};
      newState["addVehicleModal"] = modal;
      return objectAssign({}, state, newState);

    }
    case ActionTypes.RESET_FORM:
      {
        let property = objectAssign({}, state[action.propertyName], action.obj);
        let newStateResetForm = {};
        newStateResetForm[action.propertyName] = property;
        return objectAssign({}, state, newStateResetForm);      
      }

      case ActionTypes.ADD_VEHICLE:{
        return objectAssign({}, state, {vehiclePlate:action.data.vehicleReg, vehicleData:action.data});
      }
      
       
       
        default:
          return state;
      }

}


// WEBPACK FOOTER //
// ./src/reducers/accountDetailsReducer.js